import React, { FunctionComponent } from "react";
import { ParsedDate, SplittedDate } from "../../../Types";
import DayPickerBody from "./DayPickerBody";
import DayPickerHeader from "./DayPickerHeader";

interface DayPickerProps {
  selectedDate: ParsedDate | null;
  calenderDate: ParsedDate;
  onDaySelect: (date: SplittedDate) => void;
  disableFuture?: boolean;
}

const DayPicker: FunctionComponent<DayPickerProps> = ({
  selectedDate,
  calenderDate,
  disableFuture,
  onDaySelect,
}) => {
  return (
    <table>
      <DayPickerHeader />

      <DayPickerBody
        selectedDate={selectedDate}
        calenderDate={calenderDate}
        onSelect={onDaySelect}
        disableFuture={disableFuture}
      />
    </table>
  );
};

export default DayPicker;
